import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";
import {
  hasPendingLogout,
  isPasswordResetAccount,
} from "@/shared/helper/authSession.helper";
export const msalInstance = new PublicClientApplication(msalConfig);

// The reset-policy account only bridges back to sign-in; if it stays cached it can
// become the active/fallback account and trigger an endless login redirect loop.
export const clearPasswordResetAccounts = async (): Promise<void> => {
  const resetAccounts = msalInstance
    .getAllAccounts()
    .filter(isPasswordResetAccount);

  await Promise.all(
    resetAccounts.map((account) => msalInstance.clearCache({ account })),
  );
};

// Recommended: initialize before app render
export const initializeMsal = async (): Promise<void> => {
  await msalInstance.initialize();
  await clearPasswordResetAccounts();

  if (hasPendingLogout()) {
    msalInstance.setActiveAccount(null);
    return;
  }

  const accounts = msalInstance.getAllAccounts();

  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
};
